import React from 'react';
import { FadeIn } from './FadeIn';
export function AuthorityProof() {
  const quotes = [{
    text: 'Los ciclos de sueño de los bebés de 0 a 6 meses duran entre 45 y 50 minutos, con un alto porcentaje de sueño REM activo que los hace vulnerables a despertares entre ciclos.',
    source: 'Academia Americana de Pediatría'
  }, {
    text: 'Las rutinas de sueño consistentes están asociadas con menos despertares nocturnos, mejor consolidación del sueño y menor tiempo hasta el inicio del sueño en bebés de 0 a 12 meses.',
    source: 'Journal of Clinical Sleep Medicine'
  }, {
    text: 'La introducción de señales ambientales consistentes — luz, temperatura, sonido — en las primeras semanas de vida acelera el desarrollo del ritmo circadiano en recién nacidos.',
    source: 'Pediatric Sleep Research, 2019'
  }];
  return <section className="bg-crema py-24 px-6" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        <FadeIn data-id="element-20">
          <div className="text-center mb-12" data-id="element-21">
            <h2 className="text-3xl md:text-4xl font-bold text-azul-noche mb-6" data-id="element-22">
              Basado en cómo funciona realmente el cerebro de tu bebé — no en
              teorías
            </h2>
            <p className="text-lg text-texto max-w-2xl mx-auto" data-id="element-23">
              Esta guía no fue escrita con opiniones. Fue construida sobre la
              base de lo que la neurociencia del desarrollo infantil y la
              investigación sobre sueño pediátrico documentan consistentemente:
            </p>
          </div>
        </FadeIn>

        <div className="space-y-6 mb-12" data-id="element-24">
          {quotes.map((quote, index) => <FadeIn key={index} delay={0.2 + index * 0.1} data-id="element-25">
              <div className="bg-white p-8 rounded-xl shadow-sm border-l-4 border-lila-suave" data-id="element-26">
                <p className="text-lg text-texto font-serif italic mb-4" data-id="element-27">
                  "{quote.text}"
                </p>
                <p className="text-sm font-bold text-azul-noche uppercase tracking-wider" data-id="element-28">
                  — {quote.source}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-29">
          <p className="text-lg text-texto text-center max-w-3xl mx-auto bg-white/50 p-6 rounded-xl border border-white" data-id="element-30">
            Lo que encuentras en esta guía no es tendencia. No es lo que está de
            moda en TikTok. Es lo que funciona — documentado, explicado de forma
            accesible y adaptado a la realidad de una mamá latina con un bebé de
            carne y hueso.
          </p>
        </FadeIn>
      </div>
    </section>;
}